import { CTA, styled } from '@volkswagen-onehub/components-core';

export const SearchResultItemContainer = styled(CTA)`
  min-width: auto;
  min-height: auto;
  text-align: left;
  padding: 0;
  flex-direction: column;
  align-items: flex-start;

  display: flex;
  flex-direction: column;
  padding: 24px;
  border-radius: 8px;
  border: 1px solid #dfe4e8;
  background: white;
  cursor: pointer;

  &&:hover,
  &&:active,
  &&:focus:not(:focus-visible) {
    background: #f3f4f5;
  }
`;
